import { clientMonthsDataCall } from "../core/api/report-api";
import { ApiResponse } from "./client-data-manager";
import { createOption, clearOptions } from "../shared/ui/ui-helpers";
import { showLoading, hideLoading, withLoading } from "../shared/ui/load-modal";
import { ClientCarrierController } from "./client-carrier-controller";

export class ReportUIManager {
  private monthSelect: HTMLSelectElement;
  private runDataSelect: HTMLSelectElement;
  private selectClient: HTMLSelectElement;
  private reportLi: HTMLLIElement;
  private runReportBtn: HTMLButtonElement;
  private refreshMonthBtn: HTMLButtonElement;

  constructor() {
    this.monthSelect = document.querySelector<HTMLSelectElement>("#monthSelect")!;
    this.runDataSelect = document.querySelector<HTMLSelectElement>("#runDataSelect")!;
    this.selectClient = document.querySelector<HTMLSelectElement>("#clientSelect")!;
    this.reportLi = document.getElementById("reportLi") as HTMLLIElement;
    this.runReportBtn = document.getElementById("runReportBtn") as HTMLButtonElement;
    this.refreshMonthBtn = document.getElementById("refreshMonthBtn") as HTMLButtonElement;

    if (!this.monthSelect || !this.runDataSelect || !this.selectClient || !this.reportLi || !this.runReportBtn || !this.refreshMonthBtn) {
      throw new Error("One or more report UI elements were not found.");
    }

    // Initialize refreshMonthBtn as hidden since monthSelect is initially hidden
    this.refreshMonthBtn.style.display = "none";

    this.wireEvents();
  }

  private async loadMonthData() {
    const clientId = this.selectClient.value;
    const show = !!(clientId && clientId !== "0");
    console.log('Client months response:', clientId);
    this.reportLi.style.display = show ? "block" : "none";
    
    // Update button visibility when month select visibility changes
    this.updateRunReportButtonVisibility();
    
    if (show) {
      try {
        const monthsResponse = await withLoading(
              clientMonthsDataCall(clientId),
              "Loading month data..."
            );
        //console.log('Client months response:', monthsResponse);
        
        if (monthsResponse?.status === 1 && monthsResponse?.data) {
          // Clear existing options
          clearOptions(this.monthSelect);
          
          // Add default option
          this.monthSelect.appendChild(createOption("0", "Select Month"));
          
          // Populate with months data
          const data = monthsResponse.data;
          for (const [month, dataTypes] of Object.entries(data)) {
            const typesArray = Array.isArray(dataTypes) ? dataTypes.join(", ") : dataTypes;
            const displayText = `${month} (${typesArray})`;
            this.monthSelect.appendChild(createOption(month, displayText));
          }
        }
      } catch (error) {
        console.error('Error fetching client months:', error);
      } finally {

        // Hide runReportBtn when month data is refreshed (reset state)
        // We hide first in case the month selection is just the default "Select Month" option
        this.runReportBtn.style.display = "none";

        // Set default selection to the latest month
        this.monthSelect.selectedIndex = this.monthSelect.options.length - 1;

        // Trigger change event to update UI
        this.monthSelect.dispatchEvent(
          new Event("change", { bubbles: true })
        );

      }
    }
    

  }

  private wireEvents() {
    // Set up population callback to prevent onchange during initial client population
    const mappingCtrl = new ClientCarrierController(
      { searchId: "clientSearchTab1", clientId: "clientSelect", carrierId: "carrierSelect" },
      true // Only show clients with hasMapping = true
    );
    
    // Set callback to be notified when client population is complete
    mappingCtrl.setPopulationCallback(() => {
      // Now safe to set up onchange handler
      this.selectClient.onchange = async function () {
        await this.loadMonthData();
      }.bind(this);

      // Set up refresh button handler
      this.refreshMonthBtn.onclick = async function () {
        await this.loadMonthData();
      }.bind(this);
    });

    // Set up monthSelect change handler
    this.monthSelect.onchange = function() {
      this.updateRunReportButtonVisibility();
    }.bind(this);

    // Set up runDataSelect change handler
    this.runDataSelect.onchange = function() {
      this.updateRunReportButtonVisibility();
    }.bind(this);

    // Initialize the client controller
    mappingCtrl.init();
  }

  private updateRunReportButtonVisibility() {
    const monthValue = this.monthSelect.value;
    const isMonthSelectVisible = this.reportLi.style.display !== "none";
    
    // Show refreshMonthBtn only if monthSelect is visible
    if (isMonthSelectVisible) {
      this.refreshMonthBtn.style.display = "block";
    } else {
      this.refreshMonthBtn.style.display = "none";
    }
    
    // Show runReportBtn only if monthSelect is visible and has a value other than "0"
    if (isMonthSelectVisible && monthValue && monthValue !== "0") {
      this.runReportBtn.style.display = "block";
    } else {
      this.runReportBtn.style.display = "none";
    }
  }

  public setRunReportHandler(handler: () => void) {
    this.runReportBtn.onclick = handler;
  }
}
